//#region imports
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { Field, reduxForm } from "redux-form";
import moment from "moment";
import { Col, Form, FormGroup, Row, Tooltip } from "reactstrap";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { IS_UNSAVED } from "../actions/constant";
import { SetupPageWithBFCacheAndPrompt, compressImageSmart, sanitizeEncodeImage } from "../lib/helper";

import {
  Dropdown,
  IngredientIcon,
  InputText,
  ListingText,
  Loading,
  Valert,
  VautoComplete,
  DateTimePicker,
  Vmodal,
} from "../components";
import mealPlannerActions from "../actions/mealPlannerActions";
import "./styles/mealPlanner.css";
import { zIndex } from "material-ui/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";

class MealPlannerForm extends Component {
  constructor(props) {
    super(props);
    this.selectIngredientOptions = this.selectIngredientOptions.bind(this);
    this.state = {
      tooltipOpen: false,
      searchStatus: "idle",
    };
  }

  componentDidMount() { }

  toggle = (id) => {
    // this.setState({
    //   tooltipOpen: !this.state.tooltipOpen,
    //   TooltipID: id,
    // });

    const isOpen = this.state.TooltipID === id ? !this.state.tooltipOpen : true;

    this.setState(
      { TooltipID: id, tooltipOpen: isOpen },
      () => {
        if (this.state.tooltipOpen) {
          // wait for popper to position, then nudge
          requestAnimationFrame(() => this.nudgeAllergenTooltip(`mealPlannerTooltip${id}`));
          // optional: re-nudge on resize
          window.addEventListener('resize', this._mpResizeNudge);
        } else {
          this.resetAllergenTooltipNudge();
          window.removeEventListener('resize', this._mpResizeNudge);
        }
      }
    );
  };

  // one-time binder (add in constructor or as a class field)
  _mpResizeNudge = () => {
    if (!this.state.tooltipOpen || !this.state.TooltipID) return;
    this.nudgeAllergenTooltip(`mealPlannerTooltip${this.state.TooltipID}`);
  };

  nudgeAllergenTooltip = (targetId) => {
    // Find the visible tooltip for this target (left or right placement)
    const tip =
      document.querySelector('.custom-tooltip.show[x-placement^="left"]') ||
      document.querySelector('.custom-tooltip.show[data-popper-placement^="left"]') ||
      document.querySelector('.custom-tooltip.show[x-placement^="right"]') ||
      document.querySelector('.custom-tooltip.show[data-popper-placement^="right"]');

    if (!tip) return;

    const inner = tip.querySelector('.tooltip-inner');
    const target = document.getElementById(targetId);
    if (!inner || !target) return;

    // Measure and compute dynamic nudge so arrow == icon center
    const innerH = inner.getBoundingClientRect().height;
    const targetH = target.getBoundingClientRect().height || 0;
    const nudge = ((innerH - targetH) / 2 * -1) - 6;  // move bubble up by half the extra height

    inner.style.marginTop = `${Math.round(nudge)}px`;
  };

  selectIngredientOptions(e) {
    this.props.onChangeMealPlanner({
      target: { value: e, name: "addMealPlan" },
    });
  }

  vFilter(mealListAll, meal) {
    let result = [];
    mealListAll.forEach((element) => {
      if (element.meal.toLowerCase() === meal) {
        result.push(element);
      }
    });
    return result;
  }

  selectItem(id) {
    this.props.deletAlertChangeStatus(id);
  }

  resetAllergenTooltipNudge = () => {
    const tip = document.querySelector('.custom-tooltip.show');
    if (!tip) return;
    const inner = tip.querySelector('.tooltip-inner');
    if (inner) inner.style.marginTop = '';
  };


  render() {
    const {
      disabled,
      mealList,
      onChangeMealPlanner,
      addFood,
      showIncompatibeCategory,
      mealPlannerForm,
      mealItemOnClick,
      ingredientsModalHandler,
      showDeletedDataText
    } = this.props;
    let body = [];
    if (mealList && mealList.length > 0) {
      body = [
        {
          meal: this.props.t("general.BREAKFAST_MEAL_CATEGORY"),
          mealList: this.vFilter(mealList, "breakfast"),
        },
        {
          meal: this.props.t("general.LUNCH_MEAL_CATEGORY"),
          mealList: this.vFilter(mealList, "lunch"),
        },
        {
          meal: this.props.t("general.DINNER_MEAL_CATEGORY"),
          mealList: this.vFilter(mealList, "dinner"),
        },
        {
          meal: this.props.t("general.SUPPER_MEAL_CATEGORY"),
          mealList: this.vFilter(mealList, "supper"),
        },
        {
          meal: this.props.t("general.SNACK1_MEAL_CATEGORY"),
          mealList: this.vFilter(mealList, "snack1"),
        },
        {
          meal: this.props.t("general.SNACK2_MEAL_CATEGORY"),
          mealList: this.vFilter(mealList, "snack2"),
        },
        {
          meal: this.props.t("general.SNACK3_MEAL_CATEGORY"),
          mealList: this.vFilter(mealList, "snack3"),
        },
      ];
    }
    const visibleBody = (body || [])
      .map((mealItem) => ({
        ...mealItem,
        mealList: Array.isArray(mealItem.mealList)
          ? mealItem.mealList.filter((item) => item.status !== 2)
          : [],
      }))
      .filter((mealItem) => mealItem.mealList.length > 0);
    return (
      <Form>
        <FormGroup row>
          <Col zIndex={0}>
            <DateTimePicker
              name="time"
              placeholder={this.props.t("meal_planner.DATE_TEXT")}
              value={mealPlannerForm.time}
              timeDisable="true"
              onChange={(val) => {
                var result = { target: {} };
                result.target.value = moment(val).startOf("day");
                result.target.name = "time";
                if (
                  !mealPlannerForm.time ||
                  moment(result.target.value).startOf("day").unix() !=
                  moment(mealPlannerForm.time).startOf("day").unix()
                ) {
                  onChangeMealPlanner(result);
                }
              }}
              dateFormat="DD MMM YYYY"
              pageName="mealPlanner"
            />
          </Col>
          <Col>
            <Field
              name="meals"
              component={Dropdown}
              placeholder={this.props.t("meal_planner.SELECT_MEAL_TEXT")}
              options={[
                { value: "all", label: this.props.t("forum.ALL_PLACEHOLDER") },
                {
                  value: "breakfast",
                  label: this.props.t("general.BREAKFAST_MEAL_CATEGORY"),
                },
                {
                  value: "lunch",
                  label: this.props.t("general.LUNCH_MEAL_CATEGORY"),
                },
                {
                  value: "dinner",
                  label: this.props.t("general.DINNER_MEAL_CATEGORY"),
                },
                {
                  value: "supper",
                  label: this.props.t("general.SUPPER_MEAL_CATEGORY"),
                },
                {
                  value: "snack1",
                  label: this.props.t("general.SNACK1_MEAL_CATEGORY"),
                },
                {
                  value: "snack2",
                  label: this.props.t("general.SNACK2_MEAL_CATEGORY"),
                },
                {
                  value: "snack3",
                  label: this.props.t("general.SNACK3_MEAL_CATEGORY"),
                },
              ]}
              onChange={onChangeMealPlanner}
              disabled={this.props.disabled.meals}
            />
          </Col>
        </FormGroup>
        <div className={`grayList ingredient-list`}>
          {/* {body.length ? (
            body.map((mealItem, ig) => { */}
          {visibleBody.length ? (
            visibleBody.map((mealItem, ig) => {
              if (mealItem.mealList && mealItem.mealList.length > 0)
                return (
                  <div key={`${mealItem.meal}-ig`}>
                    <h3>{mealItem.meal}</h3>
                    {mealItem.mealList.map((item, i) => {
                      let desc = `${item.food.recipe}`;
                      desc = item.food.upc
                        ? desc + ` (${item.food.upc})`
                        : desc;
                      return (
                        <div
                          key={item.meal + item.food._id + ig + item.vId}
                          className="usersItem"
                        >
                          <Row
                            onClick={() => mealItemOnClick(item.vId)}
                            className={
                              "wrapper mealPlannerGridItem" +
                              this.state.deletingItem +
                              (item.isSelected ? " selected" : "")
                            }
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              wordBreak: "break-word",
                            }}
                          >
                            <div
                              style={{
                                width: "85%",
                              }}
                            >
                              {desc}
                            </div>
                            <div
                              className="mealPlanPageIcons"
                              style={{
                                width: "15%",
                                textAlign: "right",
                                zIndex: 10,
                              }}
                            >
                              {mealItem.mealList && item.food.allergen && (
                                <span style={{ textAlign: "right" }}>
                                  <span style={{ zIndex: 12 }}>
                                    <i
                                      id={`mealPlannerTooltip${item.food._id}${item.vId}`}
                                      className="fas fa-exclamation-triangle"
                                      style={{
                                        color: "#CC0000",
                                        paddingRight: "13px",
                                        zIndex: 12,
                                        cursor: "pointer",
                                      }}
                                      onMouseEnter={() =>
                                        this.toggle(item.food._id + item.vId)
                                      }
                                      onMouseLeave={() =>
                                        this.toggle(item.food._id + item.vId)
                                      }
                                    ></i>
                                  </span>
                                  <Tooltip
                                    key={this.state.TooltipID}
                                    placement="left"
                                    popperClassName="custom-tooltip mp-tooltip"
                                    isOpen={
                                      this.state.TooltipID ===
                                        item.food._id + item.vId
                                        ? this.state.tooltipOpen
                                        : false
                                    }
                                    container="body"
                                    fade={false}
                                    target={`mealPlannerTooltip${item.food._id}${item.vId}`}
                                    toggle={() =>
                                      this.toggle(item.food._id + item.vId)
                                    }
                                    modifiers={{
                                      arrow: { enabled: false }, // Disables default arrow
                                      offset: { offset: "0, 10" },
                                    }}
                                  >
                                    {item.food.allergen}
                                    <span
                                      className="custom-tooltip-arrow"
                                      data-popper-placement={"left"}
                                    ></span>
                                  </Tooltip>
                                </span>
                              )}
                              {item.food.ingredients_text && (
                                // <i
                                //   className="fas fa-info"
                                //   style={{ color: "#007bff" }}
                                //   onClick={(e) => {
                                //     e.stopPropagation();
                                //     ingredientsModalHandler(
                                //       item.food.recipe_full,
                                //       item.food.ingredients_text
                                //     );
                                //   }}
                                // />

                                <FontAwesomeIcon
                                  className="fas fa-info-circle deleteIcon ml-0"
                                  icon={faCircleInfo}
                                  style={{
                                    color: "#007bff",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    ingredientsModalHandler(
                                      item.food.recipe_full,
                                      item.food.ingredients_text
                                    );
                                  }}
                                />

                              )}
                              <i
                                className="far fa-trash-alt deleteIcon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.selectItem(item.vId);
                                }}
                              />
                            </div>
                          </Row>
                        </div>
                      );
                    })}
                  </div>
                );
            })
          ) : (
            <div className="usersItem">
              <Row style={{ padding: "4px 0 4px 4px" }}>
                <Col>
                  <div>
                    <span className="desc" />
                    {/* {this.props.t("meal_planner.INGREDIENTS_EMPTY")} */}
                      {showDeletedDataText
                        ? this.props.t("meal_planner.DELETED_DATA_DISPLAY_AREA_TEXT")
                        : this.props.t("meal_planner.INGREDIENTS_EMPTY")}
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </div>
        <FormGroup row>
          <Field component={InputText} type="hidden" name="_id" />

          <Col xs="10">
            <Field
              name="name"
              component={VautoComplete}
              disabled={disabled.newMeal}
              placeholder={this.props.t("meal_planner.ITEM_INPUT_TEXT")}
              onChangeText={(val) => {
                this.props.change("_id", "");
                onChangeMealPlanner({
                  target: { value: val, name: "newMeal", upc_clear: false },
                });
              }}
              onSelect={this.selectIngredientOptions}
              val={mealPlannerForm.newMeal}
              category="22"
              level="111111"
              cType="csize"
              append={
                mealPlannerForm.newMeal || mealPlannerForm.upc
                  ? mealPlannerForm.upc
                  : null
              }
              onClear={() => {
                onChangeMealPlanner({
                  target: { value: "", name: "newMeal", upc_clear: true },
                });
              }}
              showCross={true}
              barcodeClicked={this.props.barcodeClicked}
              barcodeImageClicked={this.props.barcodeImageClicked}
              getSearchStatus={(val) => this.setState({ searchStatus: val })}
              partialResult={this.props.partialResult}
              showPartial={
                this.props.partialResult && this.props.partialResult.length > 0
              }
              showNoneOfAbove={true}
              showNoneOfAboveText={this.props.t("BARCODE.NONE_OF_ABOVE")}
              barcodeSearch={this.props.barcodeSearch}
              addCustomAlert={this.props.addCustomAlert}
              showHistory={false}
            />
          </Col>
          <Col xs="2">
            <button
              type="button"
              className="btn btn-primary btnWide editInputSearchBtn"
              disabled={
                this.state.searchStatus === "404" && mealPlannerForm.newMeal
                  ? false
                  : disabled.addBtn
              }
              onClick={() =>
                !mealPlannerForm.contCategory ||
                  mealPlannerForm.contCategory == "02" ||
                  mealPlannerForm.contCategory == "06"
                  ? addFood()
                  : showIncompatibeCategory()
              }
            >
              {this.props.t("general.ADD_BUTTON_TEXT")}
            </button>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

class MealPlanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDuplicateError: false,
      ingredientsVmodal: false,
      ingredientsVmodalData: [],
      noSaveAlert: false,
      barcodeAlert: false,
      barcodeValue: this.props.barcodeValue,
      itemDetails: {},
      zIndex: 15,
      compressingCount: 0,
    };
    this.deletAlertChangeStatus = this.deletAlertChangeStatus.bind(this);
    this.addFood = this.addFood.bind(this);
    this.showIncompatibeCategory = this.showIncompatibeCategory.bind(this);
    this.addCustomAlert = this.addCustomAlert.bind(this);
    this.ingredientsModalHandler = this.ingredientsModalHandler.bind(this);
    this.inputFileRef = React.createRef();
    this.originalMealListAllSnapshot = [];
    this.lastSnapshotKey = "";
  }

  componentWillUnmount() {
    if (this.cleanupPage) this.cleanupPage();
  }

  componentDidMount() {
    // this.props.initialization(this.props.match.params.date);

    // ✅ Call helper that handles Contribution Cancelled for Chrome, Firefox, Safari & Edge
    // Product Not Contributed prompt display and recreate unsavedAlertData 
    this.cleanupPage = SetupPageWithBFCacheAndPrompt(this, {
      promptRefName: "ProductNotContributed",
      initCallback: () => {
        this.props.initialization(this.props.match.params.date);
      },
      // NEW: make sure we’re reading the latest storage on restores
      dirtyFlagKey: "previousPageIsDirty",
      onDirtyFlagChange: (exists) => {
        // Optional: if your page keeps any local state/Redux that depends on this flag,
        // clear it here when exists === false.
        // (Most pages don’t need anything here; the normalize step is enough.)
      },
    });
  }
  componentDidUpdate(prevProps) {
    const prevDate = prevProps.mealPlannerForm && prevProps.mealPlannerForm.time
      ? moment(prevProps.mealPlannerForm.time).format("YYYY-MM-DD")
      : "";

    const currDate = this.props.mealPlannerForm && this.props.mealPlannerForm.time
      ? moment(this.props.mealPlannerForm.time).format("YYYY-MM-DD")
      : "";

    const dateChanged = prevDate !== currDate;
    const updateModeTurnedOn = !prevProps.updateMode && this.props.updateMode;

    if (dateChanged) {
      this.originalMealListAllSnapshot = [];
      this.lastSnapshotKey = "";
    }

    const currentList = Array.isArray(this.props.mealListShow)
      ? this.props.mealListShow
      : [];

    const snapshotKey = `${currDate}__${this.props.updateMode ? "update" : "save"}`;

    if (
      this.props.updateMode &&
      currentList.length > 0 &&
      (
        updateModeTurnedOn ||
        dateChanged ||
        this.originalMealListAllSnapshot.length === 0 ||
        this.lastSnapshotKey !== snapshotKey
      )
    ) {
      this.originalMealListAllSnapshot = currentList.map((item) => ({
        ...item,
        food: item.food ? { ...item.food } : item.food,
      }));
      this.lastSnapshotKey = snapshotKey;
    }
  }


  deletAlertChangeStatus(id) {
    this.deletedId = id;
    this.props.setDeletingItem(id, true);
    if (
      (this.props.mealPlannerForm.newMeal &&
        this.props.mealPlannerForm.newMeal != "") || (this.props.mealPlannerForm.upc && this.props.mealPlannerForm.upc != "")
    ) {
      this.deleteItemValert.changeStatus();
    } else {
      this.removeItemValert.changeStatus();
    }
  }

  addFood() {
    const { mealListAll, mealPlannerForm, addFood, itemData } = this.props;
    const { newMeal, selectedFood } = mealPlannerForm;

    const sameCustomItem =
      mealListAll &&
      mealListAll.some(
        (item) =>
          item.food.recipe_full.toLowerCase() === `${newMeal.toLowerCase()} (c)`
      );

    if (selectedFood.upc || itemData) {
      return addFood();
    }

    const isValidCustomItem =
      selectedFood.is_custom === "false" ||
      !selectedFood.is_custom ||
      selectedFood._id !== "";

    if (isValidCustomItem || sameCustomItem) {
      return addFood();
    }

    this.addCustom.changeStatus();
  }

  addCustomAlert() {
    this.props.onChangeMealPlanner({
      target: { value: "", name: "newMeal", upc_clear: true },
    });
    this.addCustomVAlert.changeStatus();
  }
  showIncompatibeCategory() {
    this.showIncompatibeCategoryRef.changeStatus();
  }

  ingredientsModalHandler(title, ingredients_text) {
    let returnHTml = (
      <div className="ingredientsAreaInMealPlanner">
        <h4>{title}</h4>
        <ul>
          <span style={{ fontWeight: 500 }}>
            {this.props.t("symptoms.INGREDIENT_TEXT")}
          </span>
          {/* {ingredients.map((item) => {
            return (
              <span style={{ fontSize: 14, color: "#333" }} key={item.recipe}>
                {item.recipe}
              </span>
            );
          })} */}
          <span style={{ fontSize: 14, color: "#333" }}>
            {ingredients_text}
          </span>
        </ul>
      </div>
    );

    this.setState({
      ingredientsVmodal: true,
      ingredientsVmodalData: returnHTml,
    });
  }

  leave = (location) => {
    if (this.props.firstChange)
      return this.props.t("general.UNSAVED_LEAVE_PAGE_TEXT");
  };

  addItem(planId) {
    this.mealPlannerId = planId;

    this.props.savePage(
      this.props.mealPlannerForm.time,
      this.props.mealListAll,
      planId ? planId : undefined
    );

    /* if (
            this.props.mealPlannerForm.newMeal &&
            this.props.mealPlannerForm.newMeal.length > 0
        ) {
            this.dataInFormValert.changeStatus();
        } else {
            this.props.savePage(
                this.props.mealPlannerForm.time,
                this.props.mealListAll,
                planId ? planId : undefined
            );
        } */
  }

  posClicked() {
    this.props.savePage(
      this.props.mealPlannerForm.time,
      this.props.mealListAll,
      this.mealPlannerId || this.props.planId || undefined
    );
  }

  showAlert() {
    if (
      (this.props.mealListAll &&
        this.props.mealListAll.length > 0 &&
        this.props.firstChange) ||
      IS_UNSAVED() === "yes"
    ) {
      this.noSaveValert.changeStatus();
    } else {
      window.location.href = "/mealplansummary";
    }
  }

  addBarcodeToField() {
    this.setState({
      appendBarcode: this.props.item_barcode,
    });
    let contDefault = {
      page: "mealplanner",
      barcode: this.props.item_barcode,
      category: "02",
      mealListShow: this.props.mealListShow,
      ingredientList: this.props.ingredientList,
      mealPlannerForm: this.props.mealPlannerForm,
      mealListAll: this.props.mealListAll,
      is_custom: this.props.is_custom,
      servingSize: this.props.servingSize,
      disabled: this.props.disabled,
      updateMode: this.props.updateMode,
      counterState: this.props.counterState,
      nutritionsList: this.props.nutritionsList,
      firstChange: this.props.firstChange,
      planId: this.props.planId,
    };
    let defaultVal = JSON.stringify(contDefault);
    localStorage.setItem("contDefault", defaultVal);
  }

  barcodeAlert = () => {
    this.barcodeAlertStatus.changeStatus();
  };

  barcodeImageAlert() {
    // this.barcodeAlertStatus.changeStatus();
    this.inputFileRef.current.click();
  }

  onBarcodeSearch = () => {
    this.props.barcodeSearch(this.state.barcode, "02");
    this.setState({ barcodeValue: this.state.barcode });
    this.setState({ barcode: "" });
  };

  // submitUpcImage(image) {
  //   this.props.onSubmitUpcImage(image, "02");
  // }

  async submitUpcImage(image) {
    if (!image) return;

    this.startCompress();
    let fileToSend = image;
    try {
      // fileToSend = image.size > 1000000 ? await compressImageSmart(image) : image;

      // 1) Only compress when > 1MB (your existing helper)
      if (fileToSend.size > 1000000) {
        fileToSend = await compressImageSmart(fileToSend);
      }

      // 2) Always sanitize-encode (avoid WAF/ALB false positives)
      fileToSend = await sanitizeEncodeImage(fileToSend, {
        mimeType: "image/jpeg",
        quality: 0.88,  // or 0.90 if you prefer, but 0.88 is safer
        maxDim: 2048,
      });

      console.log("[upload] final", fileToSend.type, fileToSend.size, fileToSend.name);

    } finally {
      this.endCompress();
    }

    this.props.onSubmitUpcImage(fileToSend, "02");
  }

  startCompress = () =>
    this.setState(s => ({
      compressingCount: s.compressingCount + 1
    }));

  endCompress = () =>
    this.setState(s => {
      const next = Math.max(0, s.compressingCount - 1);
      return { compressingCount: next };
    });

  addGreyUPC = () => {
    let contDefault = JSON.parse(localStorage.getItem("contDefault"));
    if (contDefault && contDefault.barcode) {
      this.props.addGreyUPCToItemNameField(contDefault.barcode);
    }
    localStorage.removeItem("contDefault"); // ✅ Clear after clicking Continue button
    localStorage.removeItem("unContributed");
  };

  normalizeMealKey = (value) => {
    return String(value || "").trim().toLowerCase();
  };

  hasOriginalSavedDataForMeal = (originalMealListAll, selectedMeal) => {
    if (!Array.isArray(originalMealListAll) || originalMealListAll.length === 0) {
      return false;
    }

    const selected = this.normalizeMealKey(selectedMeal || "all");

    if (selected === "all") {
      return originalMealListAll.some((item) => item && item.status !== 2);
    }

    return originalMealListAll.some(
      (item) =>
        item &&
        item.status !== 2 &&
        this.normalizeMealKey(item.meal) === selected
    );
  };

  render() {
    const {
      isLoading,
      mealListShow,
      nutritionsList,
      t,
      dropDownList,
      updateMode,
      disabled,
      onChangeMealPlanner,
      typeAheadSearchOptions,
      typeAheadSearchObjects,
      mealPlannerForm,
      mealItemOnClick,
      counterState,
      deleteItem,
      replaceValertShowStatus,
      clearMealPlannerForm,
      listCombine,
      planId,
      contributeRedirectionAlert,
    } = this.props;

    const selectedMeal =
      mealPlannerForm && mealPlannerForm.meals
        ? mealPlannerForm.meals
        : "all";

    const visibleMealList = Array.isArray(mealListShow)
      ? mealListShow.filter((item) => item && item.status !== 2)
      : [];

    const isDisplayAreaEmpty =
      !mealListShow ||
      (Array.isArray(mealListShow) && visibleMealList.length === 0);

    const showDeletedDataText =
      updateMode &&
      isDisplayAreaEmpty &&
      this.hasOriginalSavedDataForMeal(
        this.originalMealListAllSnapshot,
        selectedMeal
      );
    return (
      <div className="vPage mealPlannerPage flex">
        {/*Show loading icon whenever Redux is loading OR we’re compressing:*/}
        <Loading isLoading={isLoading || this.state.compressingCount > 0} />
        <input
          style={{ display: "none" }}
          // key={this.state.barcodeKey || ""}
          type="file"
          name="file"
          id="upc-img"
          ref={this.inputFileRef}
          accept="image/*"
          multiple={false}
          onChange={(e) => {
            e.preventDefault();
            e.target.files && e.target.files.length > 0
              ? this.submitUpcImage(e.target.files[0])
              : null;
          }}
          onClick={(e) => (e.target.value = null)}
        />
        <Vmodal
          zIndex={this.state.zIndex}
          displayStatus={this.props.saveSuccess}
          data={
            <div>
              <h4>{t("general.SAVE_SUCCESSFULLY_TITLE")}</h4>
              <p>{t("meal_planner.SAVE_MEALPLAN_SUCCESSFULLY_TEXT")}</p>
            </div>
          }
          closeFunc={() => {
            this.props.clearPlanner();
            this.props.history.push("/mealplanner");
            window.location.reload();
          }}
          timedClose={2000}
        />
        <Vmodal
          zIndex={this.state.zIndex}
          displayStatus={this.state.ingredientsVmodal}
          data={this.state.ingredientsVmodalData}
          closeFunc={() => {
            this.setState({
              ingredientsVmodal: false,
              ingredientsVmodalData: "",
            });
          }}
        />
        <Valert
          zIndex={this.state.zIndex}
          display={false}
          onRef={(ref) => (this.addCustom = ref)}
          title={t("symptoms.OTHER_ENTRY_ERROR_TITLE")}
          question={t("meal_planner.ADD_CUSTOM_TEXT")}
          positiveAction={() => {
            if (this.state.barcodeAlert) {
              this.barcodeAlertStatus.changeStatus();
              this.setState({ barcodeAlert: false });
            } else {
              this.props.addFood(this.props.mealPlannerForm.newMeal);
            }

            // this.handleAddFood();
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          zIndex={this.state.zIndex}
          display={this.props.addCustomAlert}
          onRef={(ref) => (this.addCustomVAlert = ref)}
          title={t("meal_planner.OTHER_ENTRY_ERROR_TITLE")}
          question={t("meal_planner.OTHER_ENTRY_ERROR_TEXT")}
          positiveAction={() => {
            this.setState({
              barcode: this.state.barcodeValue,
              displayAddCustomAlert: false,
            });
            this.setState({ barcodeValue: "" });
            this.barcodeAlertStatus.changeStatus();
            this.props.onChangeAlertStatus({
              item: { addCustomAlert: false },
            });
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          zIndex={this.state.zIndex}
          display={this.props.itemInVerAutofill}
          title={t("symptoms.ITEM_IN_VERIFICATION_TITLE")}
          question={t("symptoms.ITEM_IN_VERIFICATION_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            this.props.onChangeAlertStatus({
              itemInVerAutofill: false,
            });
          }}
          readOnly={true}
        />

        <Valert
          zIndex={this.state.zIndex}
          display={false}
          title={this.props.t("general.SAVE_PAGE_TITLE")}
          question={t("general.SAVE_PAGE_UNSAVED_DATA_ERROR_TEXT")}
          onRef={(ref) => (this.dataInFormValert = ref)}
          positiveAction={() => this.posClicked()}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          zIndex={this.state.zIndex}
          display={false}
          onRef={(ref) => (this.removeItemValert = ref)}
          title={t("general.DELETE_CONFIRMATION_TITLE")}
          question={t("general.DELETE_CONFIRMATION_TEXT")}
          positiveAction={() => {
            deleteItem(this.deletedId);
          }}
          negativeAction={() => {
            this.props.setDeletingItem(this.deletedId, false);
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          zIndex={this.state.zIndex}
          display={false}
          onRef={(ref) => (this.deleteItemValert = ref)}
          title={t("meal_planner.NEW_ITEM_TITLE")}
          question={t("meal_planner.NEW_ITEM_DELETE_TEXT")}
          positiveAction={() => {
            deleteItem(this.deletedId);
            onChangeMealPlanner({
              target: { value: "", name: "newMeal", upc_clear: true },
            });
          }}
          negativeAction={() => {
            this.props.setDeletingItem(this.deletedId, false);
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          zIndex={this.state.zIndex}
          display={this.state.noSaveAlert}
          onRef={(ref) => (this.noSaveValert = ref)}
          title={this.props.t("meal_planner.UNSAVED_MEAL_PLAN_DATA_TITLE")}
          question={this.props.t("meal_planner.UNSAVED_MEAL_PLAN_DATA_TEXT")}
          positiveAction={() => {
            IS_UNSAVED("no");
            localStorage.removeItem("unsavedAlertData");
            this.props.history.push("/mealplansummary");
          }}
        // positiveText={t("general.POSITIVE_PROMPT_TEXT")}
        // negativeText={t("general.CANCEL")}
        />
        {/* <Valert
          zIndex={this.state.zIndex}
          //display={this.state.showDuplicateError}
          display={false}
          onRef={(ref) => (this.warningDuplicateItemValert = ref)}
          title={t("meal_planner.DUPLICATE_ENTRY_TITLE")}
          question={t("meal_planner.DUPLICATE_ENTRY_ERROR_TEXT")}
          // positiveAction={() => {
          //   // this.setState({
          //   //    showDuplicateError: false,
          //   //   });
          //   }}
          positiveText="Ok"
          readOnly={true}
        /> */}
        <Valert
          zIndex={this.state.zIndex}
          display={replaceValertShowStatus}
          title={this.props.t("meal_planner.MEAL_PLAN_REPLACE_TITLE")}
          question={this.props.t("meal_planner.MEAL_PLAN_REPLACE_TEXT")}
          positiveAction={() => {
            listCombine("combine");
          }}
          positiveText={this.props.t("meal_planner.ADD_BUTTON")}
          negativeText={this.props.t("meal_planner.REPLACE_BUTTON")}
          negativeAction={() => {
            listCombine("replace");
          }}
          disableAutoClose={true}
          thirdActionText={this.props.t("general.CANCEL")}
          ThirdAction={() => {
            listCombine("cancel");
          }}
        />
        <Valert
          zIndex={this.state.zIndex}
          display={this.props.contributeRedirectionAlert}
          title={this.props.t("BARCODE.UPC404_ERROR_TITLE")}
          question={this.props.t("BARCODE.UPC404_ERROR_TEXT.TEXT")}
          positiveAction={async () => {
            await this.addBarcodeToField();

            if ((!this.props.updateMode && !this.props.disabled.savePageBtn) || (this.props.updateMode && !this.props.disabled.updatePageBtn)) {
              sessionStorage.setItem("previousPageIsDirty", "mealplanner"); // Set previousPageIsDirty if Save Plan or Update Plan button is enabled
            }

            window.location.href = "/contribute?showBackBtn=true";
            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          positiveText={this.props.t("general.CONTRIBUTE")}
          negativeText={this.props.t("general.CANCEL")}
          negativeAction={() => {
            onChangeMealPlanner({
              target: {
                value: "",
                name: "upcToField",
                upc_clear: false,
                contributeRedirectionAlert: true,
              },
            });
            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          onRef={(ref) => (this.contributeRedirectionAlert = ref)}
          disableAutoClose={true}
          thirdActionText={this.props.t("general.NEW")}
          ThirdAction={() => {
            onChangeMealPlanner({
              target: {
                value: "",
                name: "newMeal",
                upc_clear: true,
                contributeRedirectionAlert: true,
              },
            });
            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          children={<ListingText listing={this.props.listings} />}
        />
        <Valert
          zIndex={this.state.zIndex}
          display={this.props.barcodeCategoryRef}
          onRef={(ref) => (this.barcodeCategoryRef = ref)}
          title={this.props.t("BARCODE.INCOMPATIBLE_BARCODE_CATEGORY_TITLE")}
          question={
            this.props.refdb_item
              ? t("BARCODE.INCOMPATIBLE_BARCODE_REFDB_CATEGORY_TEXT").replace(
                "{category}",
                this.props.refdb_item_category
              )
              : t("BARCODE.INCOMPATIBLE_BARCODE_HISTORY_CATEGORY_TEXT")
          }
          // positiveAction={}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            this.props.onChangeMealPlanner({
              target: {
                value: this.props.itemData,
                name: "clearField",
              },
            });
          }}
          readOnly={true}
        />

        <Valert
          zIndex={this.state.zIndex}
          display={false}
          title={this.props.t("BARCODE.INCOMPATIBLE_BARCODE_CATEGORY_TITLE")}
          question={t("BARCODE.INCOMPATIBLE_BARCODE_CONT_CATEGORY_TEXT")}
          onRef={(ref) => (this.showIncompatibeCategoryRef = ref)}
          // positiveAction={}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          positiveAction={() => {
            this.props.addFood(this.props.mealPlannerForm.newMeal);
          }}
          negativeAction={() => {
            this.props.onChangeMealPlanner({
              target: {
                value: this.props.itemData,
                name: "clearField",
              },
            });
          }}
        />

        <Valert
          zIndex={this.state.zIndex}
          display={this.props.incorrectBarcodeCategory}
          title={this.props.t("BARCODE.INCORRECT_BARCODE_CATEGORY_TITLE")}
          question={t("BARCODE.INCORRECT_BARCODE_CATEGORY_TEXT")}
          onRef={(ref) => (this.incorrectBarcodeCategory = ref)}
          // positiveAction={}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          positiveAction={() => {
            this.props.onChangeMealPlanner({
              target: {
                value: this.props.itemData,
                name: "changeMealCategory",
              },
            });

            if (this.props.showVerificationPrompt === true) {
              this.props.onChangeAlertStatus({
                showVerificationPrompt: false,
                itemInVerAutofill: true,
                incorrectBarcodeCategory: false,
              });
            }
          }}
          negativeAction={() => {
            this.props.onChangeMealPlanner({
              target: {
                value: this.props.itemData,
                name: "clearField",
              },
            });
          }}
        />
        <Valert
          display={this.props.saveError.type && this.props.saveError.type === "alreadyUsedRecipeName"}
          title={t("recipe.ALREADY_USED_RECIPE_NAME_TITLE")}
          question={t("recipe.ALREADY_USED_RECIPE_NAME_TEXT")}
          children={
            this.props.saveError && this.props.saveError.meta && this.props.saveError.meta.length > 0 && (
              <ListingText listing={this.props.saveError.meta.map(m => ({ value: m }))} />
            )
          }
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={this.props.toggleUnsaveMessage}
          readOnly={true}
        />
        <Valert
          zIndex={this.state.zIndex}
          display={false}
          onRef={(ref) => (this.barcodeVerification = ref)}
          title={t("symptoms.BARCODE_VERIFICATION_TITLE")}
          question={t("symptoms.BARCODE_VERIFICATION_TEXT")}
          positiveAction={() => {
            this.barcodeVerification.changeStatus();
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          zIndex={this.state.zIndex}
          display={this.props.barcodeFailed}
          onRef={(ref) => (this.barcodeFailed = ref)}
          title={this.props.t("BARCODE.BARCODE_ERROR_TITLE")}
          question={this.props.t("BARCODE.BARCODE_ERROR_TEXT")}
          // positiveAction={}
          positiveText={this.props.t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          zIndex={this.state.zIndex}
          display={false}
          title={this.props.t("general.ENTER_BARCODE")}
          // question={"Type your barcode below"}
          onRef={(ref) => (this.barcodeAlertStatus = ref)}
          inputField={true}
          inputType={"number"}
          showInvalid={false}
          positiveAction={this.onBarcodeSearch}
          negativeAction={(e) => this.setState({ barcode: "" })}
          inputValue={this.state.barcode}
          onChangeInput={(e) => this.setState({ barcode: e.target.value })}
          positiveText={this.props.t("general.SUBMIT")}
          negativeText={this.props.t("general.CANCEL")}
          okBtn={
            this.state.barcode && this.state.barcode.length > 3 ? false : true
          }
        />
        <Valert
          display={false}
          onRef={(ref) => (this.ProductNotContributed = ref)}
          title={this.props.t("general.PRODUCT_NOT_CONTRIBUTED_TITLE")}
          question={this.props.t("general.PRODUCT_NOT_CONTRIBUTED_TEXT")}
          positiveAction={this.addGreyUPC} // Call function to handle adding grey UPC to the Item Name field
          positiveText={t("general.CONTINUE_BUTTON")}
          negativeText={t("general.NEW")}
          negativeAction={() => {
            onChangeMealPlanner({
              target: {
                value: "",
                name: "newMeal",
                upc_clear: true,
                contributeRedirectionAlert: true,
              },
            });
            localStorage.removeItem("contDefault"); // ✅ Clear after clicking Continue button
            localStorage.removeItem("unContributed");
          }}
          children={
            <div style={{ fontSize: 14.4, color: "#555555", marginTop: 0 }}>
              <ul style={{ listStyleType: "disc", marginLeft: 12 }}>
                <li style={{ marginBottom: 5 }}>
                  {this.props.t("general.PRODUCT_NOT_CONTRIBUTED_BULLET1_TEXT")}
                </li>
                <li>
                  {this.props.t("general.PRODUCT_NOT_CONTRIBUTED_BULLET2_TEXT")}
                </li>
              </ul>
            </div>
          }
        />
        <MuiThemeProvider>
          <MealPlannerForm
            t={t}
            mealList={mealListShow}
            dropDownList={dropDownList}
            onChangeMealPlanner={onChangeMealPlanner}
            disabled={disabled}
            typeAheadSearchOptions={typeAheadSearchOptions}
            typeAheadSearchObjects={typeAheadSearchObjects}
            addFood={this.addFood}
            showIncompatibeCategory={this.showIncompatibeCategory}
            mealPlannerForm={mealPlannerForm}
            mealItemOnClick={mealItemOnClick}
            counterState={counterState}
            deleteItem={deleteItem}
            deletAlertChangeStatus={this.deletAlertChangeStatus}
            ingredientsModalHandler={this.ingredientsModalHandler}
            barcodeClicked={this.barcodeAlert}
            barcodeImageClicked={this.barcodeImageAlert.bind(this)}
            itemDetails={this.state.itemDetails}
            partialResult={this.props.partialResult}
            barcodeSearch={this.props.barcodeSearch}
            addCustomAlert={this.addCustomAlert}
            selectDeletingItem={this.state.selectDeletingItem}
            showDeletedDataText={showDeletedDataText}

          />
        </MuiThemeProvider>
        <h5 className="nutritionsListTitle">
          {this.props.t("meal_planner.NUTRIENTS_PER_SERVING_TEXT", {
            size: this.props.is_custom
              ? `(${this.props.servingSize > 0
                ? Math.floor(this.props.servingSize)
                : ""
              }?g)`
              : `(${this.props.servingSize > 0
                ? Math.floor(this.props.servingSize)
                : 0
              }g)`,
          })}
        </h5>
        <div
          className={`grayList ingredient-list`}
          style={{ flex: 1 }}
          ref="ingredients_container"
        >
          {nutritionsList &&
            nutritionsList.map((item, i) => {
              let titleClass = item.bold
                ? "nutritionsItemTitle special"
                : "nutritionsItemTitle";
              let pointerClass = item.bold
                ? "nutritionsItemAmount special"
                : "nutritionsItemAmount";
              if (item.ind === 1) {
                titleClass += " subNut";
              }
              let desc = `${item.name}`;
              return (
                <div className="nutritionsItem" key={i}>
                  <div className={titleClass}>{desc}</div>
                  <div className={pointerClass}>
                    {item.sum || 0}
                    {item.sum > 0 ? item.symbol : ""}
                  </div>
                  <div className="percentageContainerArea">
                    <div
                      className="percentageContainer"
                      style={{
                        backgroundColor:
                          item.percentage === "N/A" ? "#eee" : "white",
                      }}
                    >
                      <div
                        className={`percentagePointer ${i < 10 ? "special" : ""
                          }`}
                        style={{
                          width: `${item.percentage != "N/A" ? item.percentage : 0
                            }%`,
                        }}
                      />
                    </div>
                  </div>
                  <div className="nutritionsItemPercentage">
                    {item.percentage}
                    {item.percentage != "N/A" ? "%" : ""}
                  </div>
                </div>
              );
            })}
        </div>
        <div className="row ">
          <div className="col">
            <button
              className="btn btn-primary btnWide"
              //href="/mealplansummary"
              // onClick={() => this.props.history.push("/mealplansummary")}
              onClick={() => this.showAlert()}

            //disabled={disabled.saveBtn ? "disabled" : ""}
            >
              {this.props.t("meal_plan_summary.PAGE_TITLE")}
            </button>
          </div>
          {!updateMode ? (
            <div className="col">
              <button
                type="button"
                className="btn btn-primary btnWide"
                onClick={() => this.addItem()}
                disabled={disabled.savePageBtn}
              >
                {t("meal_plan_summary.SAVE_BUTTON")}
              </button>
            </div>
          ) : (
            <div className="col">
              <button
                type="button"
                className="btn btn-primary btnWide"
                disabled={disabled.updatePageBtn}
                onClick={() => this.addItem(planId)}
              >
                {t("meal_plan_summary.UPDATE_BUTTON")}
              </button>
            </div>
          )}
        </div>
        <Valert title="sss" />
      </div>
    );
  }
}

//#region exports
MealPlannerForm = reduxForm({
  form: "formMealPlanner",
  enableReinitialize: true,
})(MealPlannerForm);

MealPlannerForm = connect((state) => ({
  initialValues: state.mealPlanner.mealPlannerForm,
}))(MealPlannerForm);
MealPlanner = translate("translations")(MealPlanner);

const mapStateToProps = (state) => ({
  ...state.mealPlanner,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...mealPlannerActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(MealPlanner);
//#endregion



// WEBPACK FOOTER //
// ./src/pages/MealPlanner.js